import { Menu } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { routesConfig } from '../SideBar/routeConfig'; // Import the route configuration

export const Menu_Item = ({ setcollapsed }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <Menu>
      {
        routesConfig.map((item) => {
          // Check if the user's role matches the required role, if specified
          const hasRole = !item.roles || item.roles.includes(auth.user.role);

          // Check if the user has the required resource access
          const hasResource = auth.user.resources?.some(
            (resource) => resource.name === item.requiredResource || resource.name === 'all'
          );

          if (hasRole && hasResource) {
            return (
              <Menu.Item key={item.key} icon={item.icon}>
                <Link
                  to={item.path}
                  onClick={() => setcollapsed(false)}
                >
                  {item.title}
                </Link>
              </Menu.Item>
            );
          }
          return null; // Skip menu item if the user doesn't have access
        })
      }
    </Menu>
  );
};

export default Menu_Item;
